import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Navbar height
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'STOCK',
    action: () => scrollToSection('stock')
  }, {
    name: 'ELÉCTRICO',
    action: () => scrollToSection('electrico')
  }, {
    name: 'ALQUILER PARA APPS',
    action: () => scrollToSection('alquiler')
  }, {
    name: 'CONSIGNACIÓN',
    action: () => scrollToSection('consignacion')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md border-b border-brand-gold/20 py-4' : 'bg-transparent py-6'}`} data-id="element-436" data-mp="3n4oz2r2esqte">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-437" data-mp="ul0ueui0lfs">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} data-id="element-438" data-mp="5nxnijfmai5w">
          <Logo data-id="element-439" data-mp="34cw4wtblszk3" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden xl:flex items-center gap-5" data-id="element-440" data-mp="34ccxi6jkxtkb">
          {navLinks.map(link => <button key={link.name} onClick={link.action} className="text-sm font-medium text-brand-white/80 hover:text-brand-gold transition-colors tracking-wide whitespace-nowrap" data-id="element-441" data-mp="39aei4vwnm0xw">
              {link.name}
            </button>)}
          <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="text-sm font-medium text-brand-white/80 hover:text-brand-gold transition-colors tracking-wide whitespace-nowrap" data-id="element-442" data-mp="3b0jnbzkvooro">
            INVERSIONES
          </a>
          <button onClick={() => scrollToSection('contacto')} className="px-6 py-2.5 bg-brand-gold text-brand-black font-bold text-sm rounded hover:bg-brand-white transition-colors ml-2 whitespace-nowrap" data-id="element-443" data-mp="2dem768tz0viw">
            CONTACTANOS
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="xl:hidden text-brand-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-444" data-mp="7m75d9lk6no1">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-445" data-mp="a37l049dbg9x" /> : <Menu className="w-6 h-6" data-id="element-446" data-mp="f4eq1vk4m1cw" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="xl:hidden absolute top-full left-0 right-0 bg-brand-black border-b border-brand-gold/20 p-6 flex flex-col gap-6 shadow-2xl max-h-[calc(100vh-5rem)] overflow-y-auto" data-id="element-447" data-mp="15fbjgqbv2ug">
          {navLinks.map(link => <button key={link.name} onClick={link.action} className="text-left text-lg font-medium text-brand-white hover:text-brand-gold transition-colors" data-id="element-448" data-mp="sxd1ercys423">
              {link.name}
            </button>)}
          <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" onClick={() => setIsMobileMenuOpen(false)} className="text-left text-lg font-medium text-brand-white hover:text-brand-gold transition-colors" data-id="element-449" data-mp="o30hkg7ksqpt">
            INVERSIONES
          </a>
          <button onClick={() => scrollToSection('contacto')} className="w-full py-3 bg-brand-gold text-brand-black font-bold rounded mt-4" data-id="element-450" data-mp="3ozucnrrlngr7">
            CONTACTANOS
          </button>
        </div>}
    </nav>;
}